import { Box, MenuItem, Select, TextField } from "@mui/material";

const TextFieldWithSelectMenu = ({
  options,
  selectValue,
  textFieldPlaceholder,
  textFieldValue,
  onSelectChange,
  onTextFieldChange,
}: {
  options: { label: string; value: string }[];
  selectValue: string;
  textFieldPlaceholder: string;
  textFieldValue: string;
  onSelectChange: (value: string) => void;
  onTextFieldChange: (value: string) => void;
}) => {
  return (
    <Box sx={styles.container}>
      <Select value={selectValue} sx={styles.select} onChange={(event) => onSelectChange(event.target.value)}>
        {options.map((option: { label: string; value: string }) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <TextField
        fullWidth
        placeholder={textFieldPlaceholder}
        value={textFieldValue}
        sx={styles.textField}
        onChange={(event) => onTextFieldChange(event.target.value)}
      />
    </Box>
  );
};

export default TextFieldWithSelectMenu;

const styles = {
  container: {
    display: "flex",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    borderRadius: "33px",
    width: "100%",
  },
  select: {
    borderTopRightRadius: "0 !important",
    borderBottomRightRadius: "0 !important",
    borderTop: "none !important",
    borderBottom: "none !important",
    borderLeft: "none !important",
    borderRight: "1px solid var(--Gray-300, #D0D5DD)",
    paddingRight: "0",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      border: "none !important",
    },
    "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input": {
      padding: "8px 16px 8px 8px",
    },
  },
  textField: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiInputBase-root": {
      border: "none !important",
    },
  },
};
